export const GET_DTRF_REPORT_LIST = "GET_DTRF_REPORT_LIST"
export const GET_DTRF_REPORT_LIST_FAIL = "GET_DTRF_REPORT_LIST_FAIL"
export const GET_DTRF_REPORT_LIST_SUCCESS = "GET_DTRF_REPORT_LIST_SUCCESS"
export const GET_DTRF_REPORT_LIST_RESET = "GET_DTRF_REPORT_LIST_RESET"

export const getDtrfReportList = (params) => {
    return { type: GET_DTRF_REPORT_LIST, params }
}
export const getDtrfReportListFail = (response) => {
    return { type: GET_DTRF_REPORT_LIST_FAIL, response }
}
export const getDtrfReportListSuccess = (response) => {
    return { type: GET_DTRF_REPORT_LIST_SUCCESS, response }
}
export const getDtrfReportListReset = () => {
    return { type: GET_DTRF_REPORT_LIST_RESET }
}